/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isBlank } from '@ember/utils';
import Component from '@glimmer/component';
import { Platform, PLATFORM_ICONS, PLATFORM_ICONS_CLASSES, PLATFORM_LABELS } from 'cio/utils/push/platforms';

interface PushPlatformIconArgs {
  platform: Platform;
  iconClasses: string;
  iconFill: string;
}

export default class PushPlatformIcon extends Component<PushPlatformIconArgs> {
  direction = 'bottom';

  get platform() {
    return this.args.platform;
  }

  get icon() {
    return PLATFORM_ICONS[this.platform];
  }

  get label() {
    return PLATFORM_LABELS[this.platform];
  }

  get iconClasses() {
    let { iconClasses, iconFill } = this.args;
    let classes = '';
    if (iconClasses) {
      classes += iconClasses;
    }
    if (isBlank(iconFill)) {
      classes += PLATFORM_ICONS_CLASSES[this.platform] ?? '';
    }
    return classes;
  }
}
